module.exports = __webpack_public_path__ + "media/images/sidebar-1-152ceb6f85fc4160c26a38772e3504a5.jpg";